module.exports = __webpack_public_path__ + "assets/img/0f0fb51b5f36b3410430634313f948c8.png";